import { HomeLys } from 'scripts/react-components/user/my-account/pages/HomeLys'

export const getLysRoutes = () => {
  const routes = [
    {
      path: '/',
      key: 'HOME',
      exact: true,
      isPrivate: true,
      component: HomeLys
    }
  ]

  return routes
}
